import { useEffect } from "react";

// Loads Google Analytics 4 script when measurement ID is present
const GA4 = ({ measurementId }) => {
  useEffect(() => {
    if (!measurementId) return;
    if (document.querySelector(`script[data-ga4-id="${measurementId}"]`)) return;

    const s1 = document.createElement("script");
    s1.async = true;
    s1.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    s1.setAttribute("data-ga4-id", measurementId);
    document.head.appendChild(s1);

    const s2 = document.createElement("script");
    s2.setAttribute("data-ga4-id", measurementId);
    s2.text = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${measurementId}');
    `;
    document.head.appendChild(s2);
  }, [measurementId]);
  return null;
};

export default GA4;
